import React, { FC } from 'react';
import styled from 'astroturf/react';
import { Spinner } from 'js/social/shared/CreateSocialItem/Spinner';
import { Menu } from 'js/design_system/Menu';
import { PopoverMode, PopoverProps } from 'js/design_system/Popover';
import { default as UserCardBase, Props as UserProps } from '../UserCard';

const Container = styled.div`
  max-height: 208px;
  width: 100%;

  & a {
    color: currentColor;
    text-decoration: none;
  }

  & ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

const LoadingContainer = styled.div`
  @import 'stylesheets/design_system/_breakpoint.scss';
  display: flex;
  align-items: center;
  justify-content: center;
  width: 240px;
  height: 52px;

  @include for-tablet-up {
    width: 320px;
  }
`;

const UserCard = styled(UserCardBase)`
  @import 'stylesheets/design_system/_breakpoint.scss';

  width: 100%;
  cursor: pointer;
  padding: 6px 12px;
  width: 240px;

  &:active {
    background: var(--Neutral-20, #f8f8fb);
  }

  &:focus {
    border: 3px solid var(--Blue-Secondary-4, #b4c7e8);
    background: var(--Neutral-20, #f8f8fb);
  }

  &:hover {
    background: var(--Neutral-20, #f8f8fb);
  }

  @include for-tablet-up {
    width: 320px;
  }
`;

type UserType = Omit<UserProps, 'className'> & { id: number };

export type Props = {
  users: UserType[];
  loading?: boolean;
  className?: string;
  menuProps?: Partial<PopoverProps>;
  size?: 'regular' | 'small';
};

export const UserListMenu: FC<React.PropsWithChildren<Props>> = ({
  users,
  loading = false,
  className,
  children,
  menuProps = {},
  size = 'regular',
}) => (
  <Menu
    placement="bottom-start"
    mode={PopoverMode.Any}
    className={className}
    render={() => (
      <Container>
        {loading ? (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        ) : (
          <ul>
            {users.map((user) => (
              <li key={user.id}>
                <a href={user.profileUrl}>
                  <UserCard
                    {...user}
                    profileUrl={undefined}
                    size={size}
                    truncateText
                  />
                </a>
              </li>
            ))}
          </ul>
        )}
      </Container>
    )}
    {...menuProps}
  >
    {children}
  </Menu>
);
